"use client";
import { useUnit } from "effector-react";
import { FEATURES } from "@features/features-list";
import { UserAuthModule } from "@features/student/auth/model";
import { Button, ButtonType } from "@components/atoms/buttons/button";
import { SignInFormModule } from "@features/student/auth/ui/sign-in.form";
import { TextType, Typography } from "@components/atoms/typography/typography";
import React, { useState } from "react";
import { RouterModule } from "@features/shared/router";
import { AnalyticsService } from "@features/shared/analytics";
import { $platform } from "@features/launch-context/model";
import { UpsellsStatuses } from "@components/organisms/profile/upsellsStatuses";
export default function ProfilePage() {
    const studentContract = FEATURES.getByType<UserAuthModule>(UserAuthModule).getContract();
    const student = useUnit(studentContract.stores.$student);
    const signInContract = FEATURES.getByType<SignInFormModule>(SignInFormModule).getContract();
    const [logoutButtonClicked, deleteAccount] = useUnit([
        signInContract.events.logoutButtonClicked,
        signInContract.events.deleteProfileBtnClicked
    ]);
    const platform = useUnit($platform);

    const routerContract = FEATURES.getByType<RouterModule>(RouterModule).getContract();

    const routerPush = useUnit(routerContract.events.routerPush);

    const [isModalOpen, setModalOpen] = useState(false);

    const openModal = () => {
        setModalOpen(true);
        AnalyticsService.trackEvent("delete_user_clicked");
    };

    const openMailTo = () => {
        window.open("mailto:support@tixu.ai", "_blank");
    };

    const goToSettings = () => {
        routerPush("/profile/settings");
    };

    return (
        student && (
            <div id="profile">
                <div className="flex flex-row justify-between items-center mt-3 w-full ">
                    <Typography
                        type={TextType.PARAGRAPH}
                        position="left"
                        maxWidth={"80%"}
                        className={"text-ellipsis overflow-hidden"}
                    >
                        {student?.email}
                    </Typography>
                    <Button type={ButtonType.ICON_BUTTON} stay="logout" onClick={() => logoutButtonClicked()}></Button>
                </div>

                <Button type={ButtonType.ICON_TEXT_BUTTON} stay="settings" onClick={goToSettings} color={"white"}>
                    Settings
                </Button>
                <Button type={ButtonType.ICON_TEXT_BUTTON} onClick={openMailTo} stay="support" color={"white"}>
                    Contact us
                </Button>
                <UpsellsStatuses className="mt-6" />
                {["ios", "android"].includes(platform) && (
                    <div className="flex items-center justify-center w-full mt-2 p-4 text-pink-500 text-lg font-semibold leading-[122%]">
                        <span onClick={openModal} className={"cursor-pointer"}>
                            Delete my account
                        </span>
                        <div
                            className={`absolute justify-center left-0 w-full bottom-0 flex-1 items-center box-border ${
                                isModalOpen ? "flex" : "hidden"
                            } flex-col px-8 py-6 bg-white-900 z-100`}
                        >
                            <div className={"max-w-[500px] w-full"}>
                                <div className="max-w-[274px] flex flex-col justify-center items-center mx-auto my-auto">
                                    <img
                                        className="max-w-[110px]"
                                        src="/images/icons/cancel.svg"
                                        alt="course completion icon"
                                    />

                                    <h3 className="mt-6 mb-1 text-center text-2xl font-bold leading-[130%] tracking-[.156px] text-blue-100">
                                        Do you really want to delete your account?
                                    </h3>

                                    <p className="text-center text-lg font-semibold leading-[150%] tracking-[.156px] text-white-500">
                                        It can’t be undone.
                                    </p>
                                </div>

                                <Button type={ButtonType.BUTTON_BASE} color="blue" onClick={deleteAccount}>
                                    Yes, delete
                                </Button>
                                <Button
                                    type={ButtonType.BUTTON_BASE}
                                    onClick={() => setModalOpen(false)}
                                    className={"w-5xl"}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    );
}
